module.exports = __webpack_public_path__ + "img/advent_birds_mobile.5b941f64.svg";